module.exports = __webpack_public_path__ + "media/images/favicon/mstile-150x150-655f363742c436bb004d1d739629621c.png";